/* Chip size comes from the shared layout constants, applied via inline style. */
/* eslint-disable react/forbid-dom-props */
import { Handle, type Node, type NodeProps, Position } from "@xyflow/react";
import LineIcon from "pages/HomePage/components/LineIcon";
import { entityGroups } from "pages/HomePage/data";
import type { IconName } from "pages/HomePage/models";
import React from "react";

import { SATELLITE_BADGE, SATELLITE_HEIGHT, SATELLITE_WIDTH } from "./treeGraph.constants";
import type { SatelliteNodeData } from "./treeGraph.types";

import styles from "./SatelliteNode.module.css";

const iconFor = (type: string | undefined): IconName =>
	entityGroups.find((group: { icon: IconName; type: string }) => group.type === type)?.icon ?? "custom";

/**
 * A ring chip: one entity related to the selected structural node, drawn as a small round badge
 * with its title underneath. The entity's image fills the badge when it has one, its type icon
 * otherwise; the "+N more" chip carries a plus instead.
 */
const SatelliteNode = ({ data }: NodeProps<Node<SatelliteNodeData>>) => {
	const { entity, isSelected, label, tooltip } = data;
	let badge = <LineIcon name="plus" />;
	if (entity?.imageUrl) {
		badge = <img alt="" draggable={false} src={entity.imageUrl} />;
	} else if (entity) {
		badge = <LineIcon name={iconFor(entity.type)} />;
	}

	return (
		<div
			className={isSelected ? `${styles.satellite} ${styles.satelliteSelected}` : styles.satellite}
			style={{ width: SATELLITE_WIDTH, height: SATELLITE_HEIGHT }}
			title={tooltip}>
			<Handle className={styles.hiddenHandle} position={Position.Top} type="target" />
			<span className={styles.badge} style={{ width: SATELLITE_BADGE, height: SATELLITE_BADGE }}>
				{badge}
			</span>
			<span className={styles.label}>{label}</span>
			<Handle className={styles.hiddenHandle} position={Position.Bottom} type="source" />
		</div>
	);
};

export default SatelliteNode;
